import React, {useState} from 'react';
import MediaQuery from "react-responsive";
import {CloseModal, MenuBar, JobbizLogo} from "assets/icons";
import NavbarDesktop from "components/navBar/NavbarDesktop";
import LogoutNavDesktop from "components/navBar/NavbarComponents/LogoutNavDesktop";
import NavBarTitle
    from "components/navBar/NavbarComponents/navBarTitle";


const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const handleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <>
            <header className='sticky z-30 top-0 bg-white border-b border-gray-100 w-full'>
                <div className='px-2 tab:px-4 lg:px-8'>
                    <div className='flex items-center justify-between h-[70px] -mb-px'>
                        {/* Header: Left side */}
                        <MediaQuery maxWidth={768}>
                            <div className="flex px-2">
                                <JobbizLogo wh={128}/>
                            </div>
                        </MediaQuery>
                        <MediaQuery minWidth={769}>
                            <NavBarTitle/>
                        </MediaQuery>
                        {/* Header: Right side */}
                        <div className='flex items-center px-2 gap-4'>
                            <MediaQuery maxWidth={768}>
                                <LogoutNavDesktop compact />
                            </MediaQuery>
                            {/* Hamburger button   */}
                            <button className='z-50 text-gray-600 hover:text-gray-500 tab:hidden'
                                    onClick={handleMenu}>
                                {menuOpen ? <CloseModal/> : <MenuBar/>}
                            </button>
                            <MediaQuery minWidth={769}>
                                <NavbarDesktop/>
                            </MediaQuery>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};

export default Navbar;